<template>
    <div class="undo-btn"
         :style="{ top, left }"
         v-if="isShowUndo"
         @click="undoAct"
    >
        <i class="fas fa-undo" title="Hoàn tác">
        </i>
    </div>
</template>

<script>
export default {
    name: 'UndoButton',
    props: ['top', 'left', 'result_plag'],
    methods: {
        undoAct() {
            console.log('undo Act: ', this.sentenceIds)
            this.$store.dispatch('docRes/plagiarism/updateLstResultPlagIgnoredCurrent', {
                resultPlagIgnored: { sentenceIds: this.sentenceIds},
                isUndo: true
            })
            this.$emit('undo')
        }
    },
    computed: {
        isShowUndo() {
            const listResultIgnoredCurrent = this.$store.getters['docRes/plagiarism/lstResultPlagIgnoredCurrent']
            let tmpPlag = listResultIgnoredCurrent.find((e) => e.sentenceIds.includes(this.result_plag.parts[0].sentenceId))
            return !!tmpPlag
        },
        sentenceIds() {
            return this.result_plag.parts.map(part => part.sentenceId)
        },
    }
}
</script>

<style scoped>

.undo-btn {
    position: absolute;
    background-color: rgba(255, 255, 255, 0.6);
    z-index: 1000;
    cursor: pointer;
    color: #ff1600;
}

</style>
